import { render, staticRenderFns } from "./PartnerSection.vue?vue&type=template&id=45b1ca0a&scoped=true"
import script from "./PartnerSection.vue?vue&type=script&lang=js"
export * from "./PartnerSection.vue?vue&type=script&lang=js"
import style0 from "./PartnerSection.vue?vue&type=style&index=0&id=45b1ca0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1ca0a",
  null
  
)

export default component.exports